module.exports = __webpack_public_path__ + "static/media/s.0b68b911.png";